<template>
  <svg-icon
    v-if="typeof sportIcon === 'string'"
    :icon-class="sportIcon"
  />
  <span
    v-else
    class="sport-icon-container"
  >
    <img
      v-show="!active"
      class="sport-icon"
      :src="sportIcon[0]"
    >
    <img
      v-if="hasActive"
      v-show="active"
      class="sport-icon"
      :src="sportIcon[1]"
    >
  </span>
</template>

<script>
/* 运动图标 */
import getSportIcon from './sport-icon'

export default {
  name: 'SportIcon',
  props: {
    sportId: {
      type: String,
      default: '',
      required: true
    },
    // 是否支持激活状态切换
    hasActive: {
      type: Boolean,
      default: false
    },
    // 当前状态
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sportIcon() {
      return getSportIcon(this.sportId)
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.sport-icon-container {
  line-height: 1;
}

.sport-icon {
  width: 24/@rem;
  vertical-align: top;
}
</style>
